import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { map, Subscription } from 'rxjs';
import { ReleaseService } from './core_modules/common/services/release.service';
import { LocalStorageUtil } from './core_modules/utils/local-storage-util';
import { environment } from '../environments/environment';

import { GlobalLoaderComponent } from './core_modules/common/components/global-loader/global-loader.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, GlobalLoaderComponent],
})
export class AppComponent implements AfterViewInit, OnDestroy {
  title = 'creditx-frontend';

  constructor(
    private router: Router,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private releaseService: ReleaseService,
  ) {}

  ngOnInit() {
    this.loadTheme();

    this.releaseService.checkForNewRelease();
    const appTitle = this.titleService.getTitle();
  }

  loadTheme(): void {
    const primaryColor = localStorage.getItem('primaryColor');

    if (primaryColor) {
      document.documentElement.style.setProperty(
        '--mbank-primary',
        primaryColor,
      );
      document.documentElement.style.setProperty(
        '--color-primary',
        primaryColor,
      );
    }
  }

  private resetExistingDetailsWhileNavigating() {}

  ngAfterViewInit() {}

  ngOnDestroy() {}
}
